var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1944_87786)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1944_87786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.43186 18.6912H4.77274V10.5776L0 6.99805V17.2595C0 18.0505 0.640746 18.6913 1.43186 18.6913V18.6912Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2275 18.6912H19.5685C20.3595 18.6912 21.0003 18.0505 21.0003 17.2594V6.99805L16.2275 10.5776V18.6912Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2275 4.37316V10.5777L21.0003 6.99816V5.08909C21.0003 3.3196 18.9803 2.30897 17.5639 3.37091L16.2275 4.37316Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77246 10.5776V4.37305L10.4997 8.66853L16.227 4.37305V10.5776L10.4997 14.873L4.77246 10.5776Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.08909V6.99817L4.77274 10.5777V4.37317L3.43637 3.37091C2.02002 2.30897 0 3.3196 0 5.08901V5.08909Z",
    fill: "#C5221F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1944_87786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3588,
    height: 21,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1944_87786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.c4574e6ce74de9bac61687fb9a2841a4.svg";
export { ForwardRef as ReactComponent };